var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.334 6.4L4.842 9.314c-.329.384-.32 1.014 0 1.398.328.384.858.384 1.186 0l3.864-4.518a1.101 1.101 0 000-1.388L6.028.288c-.328-.384-.858-.384-1.186 0a1.07 1.07 0 00-.247.694c0 .26.089.51.247.694l2.5 2.924H.9a.9.9 0 100 1.8h6.434z",
    fill: "#956FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default "/_next/static/images/41ac3f6990f8c0f517b94e9d931b7df7.svg";
export { ForwardRef as ReactComponent };